const warrantyItemId = 43294249943197;
// デバイス保証を追加をクリックされた時の処理
const clickAddWarranty = (itemId) => {
  // 可変するカートの商品の数を取得
  const quantityElement = document.querySelector(".item_" + itemId);
  const itemQuantity = quantityElement.value;

  // カート内のタイトルにDevice || スターターキット || DEVICEが含まれているアイテムの総数、保証商品の個数を計算
  const itemsCounts = getItemsCountsInCart()
  const numberDeviceItem = itemsCounts[0];
  const numberWarranty = itemsCounts[1];

  // デバイスアイテムの総数 > 保証商品の場合かつ、増やす保証商品の数が現在の保証商品とデバイスアイテムの差額以下の場合にカートに保証商品を追加
  if (
    numberDeviceItem > numberWarranty &&
    itemQuantity <= numberDeviceItem - numberWarranty
  ) {
    // カートに保証商品を追加
    WAU.ThemeCart.addItem(warrantyItemId, { quantity: itemQuantity })
    .then(state => {
      // カート内を再レンダリング
      WAU.AjaxCart.originUpdateView();
    });
  }
};

// カート内のタイトルにDevice || スターターキット || DEVICEが含まれているアイテムの総数、保証商品の個数を計算
const getItemsCountsInCart = () => {
  // カート内のアイテムのタイトルと個数を全て取得
  const productElements = document.querySelectorAll(".ajax-cart__qty-input");
  // カート内のタイトルにDevice || スターターキット || DEVICEが含まれているアイテムの総数、保証商品の個数を計算
  let numberDeviceItem = 0;
  let numberWarranty = 0;
  let numberOtherItem = 0;

  let loopCount = productElements.length;
  const pathname = location.pathname;
  // カート画面の場合要素が倍あるため、ループ数を半分にする
  if(pathname == '/cart') {
    loopCount = loopCount / 2;
  }

  for (var i = 0; i < loopCount; i++) {
    const productElement = productElements[i];
    const title = productElement.dataset.itemTitle;
    const quantity = productElement.valueAsNumber;
    const productId = productElement.dataset.itemProductId;

    if (
      title.includes("Device") ||
      title.includes("スターターキット") ||
      title.includes("DEVICE")
    ) {
      numberDeviceItem += quantity;
    } else if (
      productId == warrantyItemId
    ) {
      numberWarranty += quantity;
    } else {
      numberOtherItem += quantity;
    }
  }

  return [numberDeviceItem, numberWarranty, numberOtherItem];
}

// レジに進むをクリックされた時の処理
const clickComparisonWarranty = (event) => {
  event.preventDefault();
  const itemsCounts = getItemsCountsInCart()
  const numberDeviceItem = itemsCounts[0];
  const numberWarranty = itemsCounts[1];
  const numberOther = itemsCounts[2];

  // デバイス保証の数がデバイス商品の数を超えていない場合
  if(numberDeviceItem >= numberWarranty) {
    clickCheckoutHidden()
    return;
  }

  // デバイス保証のみしかカートにない場合
  if(numberDeviceItem == 0 && numberWarranty >= 1) {
    window.alert('デバイス保証は単品購入出来ません。デバイスと同時購入してください。');
    return;
  }


  window.alert('デバイス保証商品がデバイス商品の数を上回っているので削除します。')

  // デバイス商品の数に保証の数を合わせる
  WAU.ThemeCart.updateItem('43294249943197:eec7cb940127e453909758d5a0677919', { quantity: numberDeviceItem })
  .then((state) => {
    // カート内を再レンダリング
    const cartConfig = WAU.AjaxCart.getCartConfig()
    WAU.AjaxCart.updateView(cartConfig, state)
    .finally(() => {
      clickCheckoutHidden();
    });
  });
}

// 隠されたレジに進むをクリックする
const clickCheckoutHidden = () => {
  // チェックボックスをチェックしていなくてもボタンをクリック出来るようにする
  const formOptions = document.querySelectorAll('.form_optins');
  formOptions.forEach(option => {
    option.required = false;
  })

  const btn = document.querySelector('#checkout-hidden-btn');
  btn.click();
}
